<template>
  <v-app>
    <v-app-bar color="surface" elevation="1">
      <router-link :to="{ name: 'home' }" class="d-flex router-link-active">
        <img
          src="@/assets/images/logo-dinamo-simbolo-dark.png"
          height="38"
          width="38"
          alt="Dinamo"
        />
      </router-link>
      <span class="text-h6 ml-3 mr-5">
        DINAMO&nbsp;
        <span class="font-weight-light">Signer</span>
      </span>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
    <v-snackbar v-model="notifyState.show" :color="notifyState.color" :timeout="notifyState.timeout">
      {{ notifyState.message }}
    </v-snackbar>
  </v-app>
</template>

<script>
import { notifyState } from './plugins/notify'

export default {
  name: 'App',
  setup() {
    return { notifyState }
  },
}
</script>
